// extracted by mini-css-extract-plugin
module.exports = {"selectedDevices":"SelectedDevices_selectedDevices__2QHxJ"};